import React, { useState, useRef } from "react";
import { CurvedTopHeader } from "./SelectYourPlan";
import TextBox from "../../components/Common/TextBox";
import TextArea from "../../components/Common/TextArea";
import {
  toTitleCase,
  getFileType,
  upperCaseEachSentenceFirst,
  getLocalStorage,
  setLocalStorage,
  trimString,
  formatPhoneNumber,
  removeLocalStorage,
  checkTutorialDisplayStatus,
} from "../../helpers/common";
import {
  AGENT_USER_FREE_PLAN,
  USER_INFO_KEY,
  BIO_MAX_COUNT,
  TESTIMONIAL_MAX_COUNT,
} from "../../constants/common";
import { handleTextBoxChange } from "../../actions/common";
import { capitalizeFirstString, loggedInUser } from "../../helpers/common";
import { textValidations } from "../../helpers/validations";
import { themeColors } from "../../themeColors";
import PlusIcon from "../../images/v2/plus-icon.svg";
import { ERROR_TEXT } from "../../constants/common";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ProfileImageCropper from "../../mobile/components/Onboarding/ProfileImageCropper";
import AgentLiketoStartModal from "../../components/Onboarding/UserRegister/AgentLiketoStartModal";
import { saveAgentInfo } from "../../services/v2/signupService";
import { pageURLs } from "@/constants";
import useUserDetailsById from "../../hooks/useUserDetailsById";

const supportedImageFormats = ["jpg", "jpeg", "png"];

const Testimonial = ({
  clientTestimonial,
  handleTestimonial,
  testimonialCounts,
  addTestimonial,
}) => {
  return (
    <div>
      {clientTestimonial.map((testimonial, index) => (
        <div
          className="textbox-wrap mb-2 position-relative agent-info-textfield"
          key={index}
        >
          <label className="agent-modal-label">
            Client Testimonial (optional)
          </label>
          <TextArea
            className="form-control txt-area"
            maxLength={1000}
            value={testimonial}
            placeholder="What your clients think..."
            onChange={(e) => handleTestimonial(e, index)}
          />
          <div className="des-count">
            <span>{testimonialCounts[index]}</span>/
            <span>{TESTIMONIAL_MAX_COUNT}</span>
          </div>
        </div>
      ))}
      <div
        onClick={addTestimonial}
        className="d-flex align-items-center add-testimonial-btn"
      >
        <img src={PlusIcon} alt="Add Icon" />
        <button className="add-another-testimonial">
          Add another testimonial
        </button>
      </div>
    </div>
  );
};

const Bio = ({ bio, handleBioChange, bioError, bioRef, bioCount }) => {
  return (
    <div className="textbox-wrap mb-2 position-relative agent-info-textfield">
      <label className="agent-modal-label">Bio (optional)</label>
      <TextArea
        className="form-control txt-area"
        maxLength={500}
        value={bio}
        errorMessage={bioError}
        placeholder="More about you..."
        errorClass="error-validation-msg"
        onChange={(e) => handleBioChange(e)}
        txtRef={bioRef}
      />
      <div className="des-count">
        <span>{bioCount}</span>/<span>{BIO_MAX_COUNT}</span>
      </div>
    </div>
  );
};

const Facebook = ({ facebookUrl, handleUrlChange, facebookUrlError }) => {
  return (
    <div className="textbox-wrap mb-2 agent-info-textfield">
      <label className="agent-modal-label">Facebook Profile (optional)</label>
      <TextBox
        id="facebookUrl"
        name="facebookUrl"
        type="text"
        value={facebookUrl}
        placeholder="Paste link to profile here"
        className={`form-control`}
        onChange={(e) => handleUrlChange(e.target.value, "facebook")}
        errorClass="error-validation-msg"
        errorMessage={facebookUrlError ? "Enter Valid URl" : ""}
        // errorMessage={firstNameError}
      />
    </div>
  );
};

const Instagram = ({ instagramUrl, handleUrlChange, instagramUrlError }) => {
  return (
    <div className="textbox-wrap mb-2 agent-info-textfield">
      <label className="agent-modal-label">Instagram Profile (optional)</label>
      <TextBox
        id="instagramUrl"
        name="instagramUrl"
        value={instagramUrl}
        type="text"
        placeholder="Paste link to profile here"
        className={`form-control`}
        errorClass="error-validation-msg"
        onChange={(e) => handleUrlChange(e.target.value, "instagram")}
        errorMessage={instagramUrlError ? "Enter Valid URl" : ""}
        // errorMessage={lastNameError}
      />
    </div>
  );
};

const Youtube = ({ youtubeUrl, handleYoutubeUrl, youtubeUrlError }) => {
  return (
    <div className="textbox-wrap mb-3 mb-sm-3 agent-info-textfield">
      <label className="agent-modal-label">Youtube Video (optional)</label>
      <TextBox
        id="youtubeUrl"
        name="youtubeUrl"
        type="text"
        value={youtubeUrl}
        placeholder="Paste video embed link here"
        className={`form-control`}
        onChange={(e) => handleYoutubeUrl(e.target.value)}
        errorClass="error-validation-msg"
        errorMessage={youtubeUrlError ? "Enter Valid Youtube URl" : ""}
        // errorMessage={firstNameError}
      />
    </div>
  );
};

const Avatar = ({
  imageUrl,
  handleImageUpload,
  imgError,
  handleLogoUpload,
  logoError,
}) => (
  <div className="avatar-section">
    <div className="avatar-row">
      <div className="prof-img">
        {imageUrl ? (
          <img src={`${imageUrl}?${Math.random().toString(36)}`} />
        ) : (
          <svg
            width="24"
            height="23"
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.3643 21.1875C21.7317 18.375 19.1183 16.264 16.0253 15.2594C17.5078 14.3778 18.6599 13.0338 19.3046 11.4339C19.9493 9.83406 20.0508 8.06678 19.5937 6.40358C19.1365 4.74039 18.146 3.27329 16.7741 2.22766C15.4023 1.18204 13.7252 0.615723 12.0003 0.615723C10.2754 0.615723 8.59824 1.18204 7.22643 2.22766C5.85462 3.27329 4.86405 4.74039 4.4069 6.40358C3.94975 8.06678 4.05131 9.83406 4.69597 11.4339C5.34063 13.0338 6.49273 14.3778 7.97529 15.2594C4.88227 16.264 2.2689 18.375 0.636225 21.1875C0.556066 21.3194 0.513672 21.4707 0.513672 21.625C0.513672 21.7793 0.556066 21.9307 0.636225 22.0625C0.711012 22.1966 0.820597 22.308 0.953423 22.385C1.08625 22.462 1.23739 22.5018 1.39091 22.5H22.6097C22.7632 22.5018 22.9143 22.462 23.0472 22.385C23.18 22.308 23.2896 22.1966 23.3643 22.0625C23.4445 21.9307 23.4869 21.7793 23.4869 21.625C23.4869 21.4707 23.4445 21.3194 23.3643 21.1875Z"
              fill={themeColors.neutral450}
            />
          </svg>
        )}
      </div>

      <div className="d-flex flex-column align-items-start">
        <div className="upload-btn-innerwrap position-relative mb-1">
          <input
            type="file"
            name="profileImage"
            id="profileImage"
            onChange={handleImageUpload}
          />
          <label
            htmlFor="profileImage"
            className="active agent-user-btn new-agent-user-btn"
          >
            {imageUrl ? "Replace Profile Image" : "Add Profile Image"}
          </label>
          <span className="error-msg w-125 h-auto">{imgError}</span>
        </div>
        <span className="avatar-note">*Highly Recommended*</span>
      </div>
    </div>

    {/* <button type="button" className="btn-add-logo">Add Logo</button> */}
    <div className="upload-btn-innerwrap new-upload-btn-innerwrap addyour-property-details-wrap mb-12">
      <label
        htmlFor="logoUrl"
        // className={`btn-outline-secondary`}
      >
        Add Logo
      </label>
      <input
        type="file"
        name="logoUrl"
        id="logoUrl"
        onChange={(e) => handleLogoUpload(e)}
        className=" "
      />
      <span className="error-msg w-104 h-auto error-wordbreak">
        {logoError}
      </span>
    </div>
  </div>
);

const Website = ({ websiteUrl, handleUrlChange, websiteUrlError }) => {
  return (
    <div className="textbox-wrap mb-3 mb-sm-3 agent-info-textfield">
      <label className="agent-modal-label">Website (optional)</label>
      <TextBox
        id="websiteUrl"
        name="websiteUrl"
        type="text"
        value={websiteUrl}
        placeholder="Paste link to website here"
        className="form-control"
        onChange={(e) => handleUrlChange(e.target.value, "website")}
        errorClass="error-validation-msg"
        errorMessage={websiteUrlError ? "Enter Valid URl" : ""}
        // errorMessage={firstNameError}
      />
    </div>
  );
};

const CompleteYourProfilePremium = () => {
  const [facebookUrl, setFacebookUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [imgError, setImgError] = useState("");
  const [clientTestimonial, setTestimonials] = useState([""]);
  const [testimonialCounts, setTestimonialCounts] = useState([0]);
  const [bio, setBio] = useState("");
  const [instagramUrlError, setInstagramUrlError] = useState(false);
  const [websiteUrlError, setWebsiteUrlError] = useState(false);
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);
  const [facebookUrlError, setFacebookUrlError] = useState(false);
  const [bioCount, setBioCount] = useState(0);
  const [logoError, setLogoError] = useState("");
  const [changedImage, setChangedImage] = useState(null);

  const [bioCursorPos, setBioCursorPos] = useState(0);
  const [isSquareImage, setIsSquareImage] = useState(false);
  const [bioError, setBioError] = useState("");
  const bioRef = useRef();

  const [imageUrl, setImageUrl] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [agentPreference, setAgentPreference] = useState();
  const [agentPreferenceModal, setAgentPreferenceModal] = useState(false);

  const [showPofileImageUploadModal, setShowPofileImageUploadModal] =
    useState(false);
  const ShowPofileImageUploadModalClose = () =>
    setShowPofileImageUploadModal(false);
  const ShowPofileImageUploadModalShow = (isSquareImage) => {
    setIsSquareImage(isSquareImage);
    setShowPofileImageUploadModal(true);
  };

  const user = loggedInUser();
  const userDetails = useUserDetailsById(user.userInfo.userId, true);

  console.log("userDetails", userDetails);

  let DisplayWantAddOnboard = checkTutorialDisplayStatus(6);
  let DisplayInventoryAddOnboard = checkTutorialDisplayStatus(7);

  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);

  const navigate = useNavigate();

  const addTestimonial = () => {
    setTestimonials((prevTestimonials) => [...prevTestimonials, ""]);
    setTestimonialCounts((prevCounts) => [...prevCounts, 0]);
  };

  const handleBioChange = (e) => {
    setBioError("");
    const _bio = handleTextBoxChange(e);
    if (!textValidations(_bio)) {
      setBioError(ERROR_TEXT);
    }
    let value = capitalizeFirstString(_bio);
    value = upperCaseEachSentenceFirst(value);
    if (trimString(value) != "") {
      setBioCursorPos(e.target.selectionStart);
    }
    setBioCount(value.length);
    setBio(value);
  };

  const handleTestimonial = (e, index) => {
    const value = e.target.value;
    const updatedTestimonials = [...clientTestimonial];
    const updatedCounts = [...testimonialCounts];

    updatedTestimonials[index] = value;
    updatedCounts[index] = value.length;

    setTestimonials(updatedTestimonials);
    setTestimonialCounts(updatedCounts);
  };

  const handleUrlChange = (url, type) => {
    const trimmedUrl = url?.trim() || ""; // Ensure it's a string
    const websiteUrlRegex =
      /^(https?:\/\/)?([\w\-]+\.)+[\w]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    // Allow empty value, but validate only when there is input
    const isValid = trimmedUrl === "" || websiteUrlRegex.test(trimmedUrl);

    switch (type) {
      case "facebook":
        setFacebookUrl(trimmedUrl);
        setFacebookUrlError(trimmedUrl !== "" && !isValid); // Error only if input is invalid
        break;
      case "instagram":
        setInstagramUrl(trimmedUrl);
        setInstagramUrlError(trimmedUrl !== "" && !isValid);
        break;
      case "website":
        setWebsiteUrl(trimmedUrl);
        setWebsiteUrlError(trimmedUrl !== "" && !isValid);
        break;
      default:
        break;
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    let isValid = true;
    if (!_.includes(supportedImageFormats, selectedFileType)) {
      isValid = false;
      setImgError("Select Valid Image");
    }
    if (isValid) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          ShowPofileImageUploadModalShow(false);
          setChangedImage(reader.result);
        };
        reader.readAsDataURL(file);
        // Reset the file input
        e.target.value = null;
      }
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    let isValid = true;
    if (!_.includes(supportedImageFormats, selectedFileType)) {
      isValid = false;
      setLogoError("Select Valid Image");
    }
    if (isValid) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          ShowPofileImageUploadModalShow(true);
          setChangedImage(reader.result);
        };
        reader.readAsDataURL(file);
        // Reset the file input
        e.target.value = null;
      }
    }
  };

  const checkValid = () => {
    if (websiteUrlError || youtubeUrlError) {
      return true;
    }
    return false;
  };

  const handleYoutubeUrl = (url) => {
    setYoutubeUrl(url);
    setYoutubeUrlError(false);
  };

  const handleSubmit = async () => {
    console.log("userDetails", userDetails);
    const firstName = userDetails.FirstName;
    const lastName = userDetails.LastName;
    const name = firstName + " " + lastName;

    const agentInfo = {
      FirstName: firstName,
      LastName: lastName,
      Phone: userDetails.Phone,
      Location: userDetails.Location,
      Company: userDetails.Company,
      LicenseNo: userDetails.LicenseNo,
      Bio: bio,
      clientTestimonial: clientTestimonial,
      facebookUrl: facebookUrl,
      instagramUrl: instagramUrl,
      websiteUrl: websiteUrl,
      youtubeUrl: youtubeUrl,
      logoUrl: logoUrl,
      img: imageUrl,
    };

    await saveAgentInfo(agentInfo).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          const _userDetails = getLocalStorage(USER_INFO_KEY);
          if (_userDetails) {
            _userDetails.userInfo.userStatus = true;
            _userDetails.userInfo.image = userDetails.img;
          }
          setLocalStorage(USER_INFO_KEY, _userDetails);
          navigate(`${pageURLs.home}?showAgentModal=1`);
        } else {
          console.log("Something went wrong");
        }
      }
    });

    console.log("submit");
  };

  const handleSkip = () => {
    navigate(`${pageURLs.home}?showAgentModal=1`);
  };

  return (
    <>
      <CurvedTopHeader />
      <div className="pro-onboarding-container">
        <h1 className="onboarding-title">
          Welcome to Pro!{" "}
          <span role="img" aria-label="party">
            🎉
          </span>
        </h1>
        <p className="onboarding-subtitle">Let's level up your visibility!</p>

        <Avatar
          imageUrl={imageUrl}
          handleImageUpload={handleImageUpload}
          imgError={imgError}
          handleLogoUpload={handleLogoUpload}
          logoError={logoError}
        />

        <Bio
          bio={bio}
          handleBioChange={handleBioChange}
          bioError={bioError}
          bioRef={bioRef}
          bioCount={bioCount}
        />

        <Testimonial
          clientTestimonial={clientTestimonial}
          handleTestimonial={handleTestimonial}
          testimonialCounts={testimonialCounts}
          addTestimonial={addTestimonial}
        />

        <div className="social-grid">
          <Facebook
            facebookUrl={facebookUrl}
            handleUrlChange={handleUrlChange}
            facebookUrlError={facebookUrlError}
          />
          <Instagram
            instagramUrl={instagramUrl}
            handleUrlChange={handleUrlChange}
            instagramUrlError={instagramUrlError}
          />
          <Website
            websiteUrl={websiteUrl}
            handleUrlChange={handleUrlChange}
            websiteUrlError={websiteUrlError}
          />
          <Youtube
            youtubeUrl={youtubeUrl}
            handleYoutubeUrl={handleYoutubeUrl}
            youtubeUrlError={youtubeUrlError}
          />
        </div>

        <div className="action-buttons">
          <button className="btn-new-outline-secondary" onClick={handleSkip}>
            Skip
          </button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={checkValid()}
          >
            Continue
          </Button>
        </div>
      </div>

      <ProfileImageCropper
        userId={UserId}
        image={changedImage}
        show={showPofileImageUploadModal}
        onHide={() => {
          ShowPofileImageUploadModalClose();
        }}
        isSquare={isSquareImage}
        updateImageAfterCrop={(imageUrl) => {
          if (isSquareImage) {
            setLogoUrl(imageUrl);
          } else {
            setImageUrl(imageUrl);
          }
          ShowPofileImageUploadModalClose();
        }}
      />
    </>
  );
};

export default CompleteYourProfilePremium;
